import { render, staticRenderFns } from "./contractDetail.vue?vue&type=template&id=0c567987&scoped=true"
import script from "./contractDetail.vue?vue&type=script&lang=js"
export * from "./contractDetail.vue?vue&type=script&lang=js"
import style0 from "./contractDetail.vue?vue&type=style&index=0&id=0c567987&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c567987",
  null
  
)

export default component.exports